<template>
  <el-tooltip placement="bottom-start">
    <i class="jc-icon-monitor icon"></i>
    <template slot="content">
      <i18n tag="span" path="privateNetInstance.agent.installWarn2">
        <a :href="Config.AGENT_URL" target="_blank" place="link" class='blue' style="color:#2C68FF">{{$t('privateNetInstance.agent.plugin') }}</a>
      </i18n>
<!--       <i18n v-else tag="span" path="privateNetInstance.agent.installWarnWindows"></i18n>
 -->    </template>

  </el-tooltip>
 
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      requires: true
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  cursor: pointer;
  color: #2C68FF;

  &:hover {
    color: #53aef8;
  }

  .blue {
    color: #2aafff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PerformanceMonitorIcon.vue